import { usePolledCounter } from "@hiya/ui";
import { getBadgeCounts } from "../api/orders";
import type { BadgeCounts } from "../types/orders";

const POLL_INTERVAL = 30_000;
const INITIAL: BadgeCounts = {
  orders: 0,
  samples_at_lab: 0,
  results_received: 0,
  reports_published: 0,
};

export function useBadgeCounts() {
  const { data: counts, refresh } = usePolledCounter(
    getBadgeCounts,
    INITIAL,
    POLL_INTERVAL,
  );
  return { counts, refresh };
}
